<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->


<template>
	<div>
	</div>
</template>

<script>


import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	extends: BaseComponent,
	data() {
		return {};
	},
	computed: {},
	created() {
	},
	methods: {

		onNextClicked() {
			this.onNextConfirmed();
		},
		onNextConfirmed() {
			this.$emit("onNextConfirmed")
		},
		showProgress() {
			this.$emit("showProgress", true)
		},
		hideProgress() {
			this.$emit("showProgress", false)
		}

	},

}
</script>

